import Swiper from './../../imports/import-swiper';

export default () => {
    const sliders = document.querySelectorAll('.v-types__item-slider');
    const blocks = document.querySelectorAll('.v-types__item');
    const verticalSliderContainer = document.querySelector('.v-types__carousel');
    sliders.length ? initSliders() : false;
    blocks.length ? blockExpand() : false;
    if (verticalSliderContainer) {
        window.addEventListener('load', verticalSlider)
    }

    function initSliders() {
        sliders.forEach(function (sliderEl) {
            let parent = sliderEl.closest('.v-types__item');
            let paginationEl = parent.querySelector('.v-types__item-pagination');
            const slidersElements = sliderEl.querySelectorAll(".v-types__item-slide");
            //console.log(slidersElements);

            if (slidersElements.length > 1) {
                const slider = new Swiper(sliderEl, {
                    wrapperClass: 'v-types__item-slider-wrapper',
                    slideClass: 'v-types__item-slide',
                    speed: 700,
                    allowTouchMove: true,
                    spaceBetween: 50,
                    loop: true,
                    autoplay: {
                        delay: 10000,
                    },
                    pagination: {
                        el: paginationEl,
                        type: 'bullets',
                        clickable: true,
                        renderBullet: function (index, className) {
                            return '<span class="' + className + '"><span></span></span>';
                        }
                    }
                });
            }
        });
    }

    function blockExpand() {
        blocks.forEach(function (block) {
            let openBtn = block.querySelector('.v-types__item-btn-details');
            let closeBtn = block.querySelector('.v-types__details-btn-close');
            let details = block.querySelector('.v-types__details');

            if (openBtn && closeBtn) {
                openBtn.addEventListener('click', (e) => {
                    e.preventDefault();

                    let isOpened = openBtn.classList.toggle('is-active');
                    setDetailsState(isOpened);
                });

                closeBtn.addEventListener('click', (e) => {
                    e.preventDefault();

                    setDetailsState(false);
                });
            }

            function setDetailsState(opened) {
                if (opened) {
                    block.classList.add('is-expanded');
                    details.classList.add('is-active');
                    openBtn.classList.add('is-active');
                } else {
                    block.classList.remove('is-expanded');
                    details.classList.remove('is-active');
                    openBtn.classList.remove('is-active');
                }
            }
        });
    }

    function verticalSlider() {
        verticalSliderContainer.style.height = verticalSliderContainer.querySelector('.v-types__item-main').offsetHeight + 'px';

        const slider = new Swiper(verticalSliderContainer, {
            direction: 'vertical',
            setWrapperSize: true
        })
    }
}
